module.exports = __webpack_public_path__ + "img/image-3.ea05d285.png";